<template>
  <RightPanel
    v-if="faqAvailable"
    icon="QuestionFilledElementIcon"
    panel-type="faq"
    :button-top="topOffset"
    :max-width="maxWidth"
    :backdrop="backdrop"
    :show-by-default="false"
    :faq-page="page"
  >
    <Faqs />
  </RightPanel>
</template>
<script lang="ts">
import { defineComponent, computed, ref, watch, onMounted } from 'vue'
import RightPanel from '@/components/RightPanel.vue'
import Faqs from '@/components/FaqPanel/Faqs.vue'
import { useConfigStore } from '@/store/modules/config'
import useResize from '@/hooks/useResize'

import { useFaqsStore } from '@/store/modules/faqs'
import { IFaqsPayload } from '@/api/faqs'
export default defineComponent({
  name: 'FaqPanel',
  components: {
    RightPanel,
    Faqs
  },
  props: {
    page: {
      type: String,
      required: true
    },
    maxWidth: {
      type: Number,
      default: 400
    },
    topOffset: {
      type: Number,
      default: 140
    },
    backdrop: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { isDesktop } = useResize()
    const configStore = useConfigStore()
    const faqsStore = useFaqsStore()
    const faqAvailable = computed(() => {
      return configStore.currentConfig.faq_pages.includes(props.page)
    })
    const update = () => {
      faqsStore.SetFilters({ page: props.page })
      faqsStore.FetchItems()
    }
    watch(faqAvailable, (newValue, oldValue) => {
      update()
    })

    onMounted(() => {
      if (faqAvailable.value) {
        update()
      }
    })
    return { faqAvailable, isDesktop }
  }
})
</script>
